export default "__VITE_ASSET__5cf1289e__"